import { useSwiper } from "swiper/react";

export default function SlideNextButton() {
  const swiper = useSwiper();

  return (
    <div
      className="swiper-arrows swiper-next"
      onClick={() => swiper.slideNext()}
    ></div>
  );
}
